"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsFactory = void 0;
const Account_1 = require("../sub-clients/accounts/model/Account");
const AccountPrices_1 = require("../sub-clients/accounts/model/AccountPrices");
const Price_1 = require("../sub-clients/videos/model/Price");
class AccountsFactory {
    static sample(account) {
        return {
            id: 'account-1',
            name: 'Kettle Chips',
            manager: 'Mz Salt',
            products: [Account_1.Product.INTEGRATE, Account_1.Product.CLASSROOM],
            status: Account_1.AccountStatus.ACTIVE,
            type: Account_1.AccountType.STANDARD,
            marketSegment: Account_1.MarketSegment.HIGHER_EDUCATION,
            features: {
                BO_WEB_APP_PRICES: true,
                LTI_AGE_FILTER: true,
                BO_WEB_APP_REQUEST_TRIMMING: false,
                BO_WEB_APP_REQUEST_ADDITIONAL_EDITING: false,
            },
            totalActiveUsers: 1,
            ...account,
        };
    }
    static sampleApiClient(client) {
        return {
            id: 'client-1',
            secret: 'top-secret',
            ...client,
        };
    }
    static samplePrices(prices) {
        return {
            channelPrices: [
                {
                    channelId: 'channel1',
                    customPrice: {
                        amount: 0.5,
                        currency: 'CREDITS',
                    },
                    channelName: 'My channel name',
                    isShownToUser: true,
                },
            ],
            assetTypePrices: [
                {
                    assetType: AccountPrices_1.AssetType.STOCK_VIDEO,
                    customPrice: { amount: 0.25, currency: 'CREDITS' },
                    evaluatedPriceType: Price_1.PriceType.DEFAULT,
                    warning: 'There is a warning here',
                    priceShownToUser: { amount: 0.5, currency: 'CREDITS' },
                },
                {
                    assetType: AccountPrices_1.AssetType.INSTRUCTIONAL_VIDEO,
                    customPrice: { amount: 0.25, currency: 'CREDITS' },
                    evaluatedPriceType: Price_1.PriceType.DEFAULT,
                    warning: 'There is a warning here',
                    priceShownToUser: { amount: 0.2, currency: 'CREDITS' },
                },
                {
                    assetType: AccountPrices_1.AssetType.PODCAST,
                    customPrice: { amount: 0.25, currency: 'CREDITS' },
                    evaluatedPriceType: Price_1.PriceType.DEFAULT,
                    warning: 'There is a warning here',
                    priceShownToUser: { amount: 0.2, currency: 'CREDITS' },
                },
                {
                    assetType: AccountPrices_1.AssetType.NEWS_VIDEO,
                    customPrice: { amount: 0.25, currency: 'CREDITS' },
                    evaluatedPriceType: Price_1.PriceType.DEFAULT,
                    warning: 'There is a warning here',
                    priceShownToUser: { amount: 0.27, currency: 'CREDITS' },
                },
                {
                    assetType: AccountPrices_1.AssetType.PREMIUM_VIDEO,
                    customPrice: { amount: 0.25, currency: 'CREDITS' },
                    evaluatedPriceType: Price_1.PriceType.DEFAULT,
                    warning: 'There is a warning here',
                    priceShownToUser: { amount: 0.3, currency: 'CREDITS' },
                },
            ],
            ...prices,
        };
    }
}
exports.AccountsFactory = AccountsFactory;
//# sourceMappingURL=AccountsFactory.js.map